<span class="loader"
[style.width.px]="width"
[style.height.px]="width"
[style.--thickness]="thickness + 'px' "
[style.--primaryColor]="primaryColor"
[style.--secondaryColor]="secondaryColor"></span>